import { hydrate, render } from 'react-dom';
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { AuthProvider } from "context/AuthContext";
import { MaterialUIControllerProvider } from "context";
import { StytchB2BProvider } from '@stytch/react/b2b';
import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b';

const stytchOptions = {
    cookieOptions: {
        opaqueTokenCookieName: "stytch_session",
        jwtCookieName: "stytch_session_jwt",
        path: "",
        availableToSubdomains: false,
        domain: "",
    }
}

const stytch = new StytchB2BUIClient(
    process.env.REACT_APP_STYTCH_PUBLIC_TOKEN,
    stytchOptions
);

const rootElement = document.getElementById('root');

// The app wrapped with all required providers
const AppWithProviders = () => (
    <StytchB2BProvider stytch={stytch}>
        <BrowserRouter>
            <AuthProvider>
                <MaterialUIControllerProvider>
                    <App />
                </MaterialUIControllerProvider>
            </AuthProvider>
        </BrowserRouter>
    </StytchB2BProvider>
);

// Handle both React-snap pre-rendering and normal rendering
if (rootElement?.hasChildNodes()) {
    hydrate(<AppWithProviders />, rootElement);
} else {
    render(<AppWithProviders />, rootElement);
}
